/** Copying is optional: a successfully created share must stay accessible. */
export async function copyShareLink(url: string, clipboard?: Pick<Clipboard, 'writeText'>): Promise<boolean> {
  try {
    if (!clipboard) return false;
    await clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
